import React from 'react';

interface FormAndCalloutBoxProps {
  children: React.ReactNode;
}

interface FormAndCalloutBoxComponent extends React.FC<FormAndCalloutBoxProps> {
  Form: React.FC<{ children: React.ReactNode }>;
  Callout: React.FC<{ children: React.ReactNode }>;
}

const FormAndCalloutBox: FormAndCalloutBoxComponent = ({
  children
}) => {
  return (
    <div className="mz-form-and-callout-box">
      <div className="mz-container">
        <div className="mz-full-width grid-inner-2-10-md grid-inner-2-10-lg mz-form-and-callout-box__inner">
          {children}
        </div>
      </div>
    </div>
  );
};

FormAndCalloutBox.Form = ({ children }) => <div className={(window as any).bnp_retailer_mode ? "" : "mz-form-and-callout-box__form"}>{children}</div>;
FormAndCalloutBox.Callout = ({ children }) => <div className="mz-form-and-callout-box__callout">{children}</div>;

export default FormAndCalloutBox;
